/**
 * @description
 * Determine if a value is a view on an ArrayBuffer
 *
 * @example
 * ``` ts
 * isArrayBufferView(new DataView(new ArrayBuffer(2)));
 * // => true
 * ```
 *
 * @param {Object} value The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 *
 * @docsCategory preference/lang
 * @codeFilter is-array-buffer-view
 */
export function isArrayBufferView(value): value is ArrayBufferView {
  let result;
  if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
    result = ArrayBuffer.isView(value);
  } else {
    result = value && value.buffer && value.buffer instanceof ArrayBuffer;
  }
  return !!result;
}
